import styled from 'styled-components'

export const AppContainer = styled.div`
  height: 100%;
  width: 100%;
  background-size: cover;
`
